export default class Palette {

    static WELL_BLUE = "#47bcc6"
    static IIDEC_LIGHT_PALE_RED = "#f37e55"

}
